// extracted by mini-css-extract-plugin
export default {"logos":"K95J0","image":"QxjVl","text":"a70_y","grid":"QcG9e","photos":"t6trY","photo":"UsHph","infoTitle":"STu47","infoText":"FbPus","link":"RuiX4"};